import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppAuth } from './API';
import logger from './utils/logger';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

async function initializeApp() {
    try {
        await AppAuth.initializeToken();
        // Continue with app initialization
    } catch (error) {
        // Handle initialization error
        logger.error('App authentication failed:', error);
    }
}

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        //console.log('ServiceWorker registration successful');
        
        // Check for updates on page load
        registration.update();
        
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour
        
        // Handle updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Check if user agent is a crawler/bot
                const userAgent = navigator.userAgent.toLowerCase();
                const isCrawler = /bot|crawler|spider|googlebot|bingbot|yahoo|duckduckbot|baiduspider|yandex|sogou|exabot|facebookexternalhit/i.test(userAgent);
                
                if (isCrawler) {
                  // Automatically update for crawlers without prompting
                  window.location.reload();
                } else {
                  // For regular users, show the update prompt
                  console.log('New content is available; please refresh.');
                  if (window.confirm('New version of the app is available! Reload to update?')) {
                    window.location.reload();
                  }
                }
              }
            });
          }
        });
      })
      .catch(err => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}

// Initialize app and render
initializeApp().then(() => {
  root.render(
    //<React.StrictMode>
      <App />
    //</React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
});
